module.exports = __webpack_public_path__ + "static/media/undraw_no_data_qbuo.9ccc9e3d.svg";